import {Box, Grid, GridProps, HStack, useMultiStyleConfig} from '@chakra-ui/react'
import React from 'react'

interface BannerHalfProps {
    products?: React.ReactNode
    module?: React.ReactNode
    variant: 'grid2' | 'grid3'
}

const BannerHalf = React.memo(({products, module, variant}: BannerHalfProps) => {
    const styles = useMultiStyleConfig('BannerHalf', {variant}) as Record<string, GridProps>

    return (
        <HStack {...styles.container} data-testid="product-listing-banner-half">
            <Grid {...styles.productsGrid} data-testid="product-listing-banner-half-products">
                {products}
            </Grid>
            <Box {...styles.moduleWrapper} data-testid="product-listing-banner-half-module">
                {module}
            </Box>
        </HStack>
    )
})

BannerHalf.displayName = 'BannerHalf'

export {BannerHalf}
